const CERTIFICATE_STATUS = {
  en: {
    'Certificate status draft': 'Draft',
    'Certificate status active': 'Active',
    'Certificate status fully_redeemed': 'Fully redeemed',
    'Certificate status expired': 'Expired',
    'Certificate status refunded': 'Refunded',
  },
  uk: {
    'Certificate status draft': 'Чернетка',
    'Certificate status active': 'Активний',
    'Certificate status fully_redeemed': 'Використаний',
    'Certificate status expired': 'Прострочений',
    'Certificate status refunded': 'Повернений',
  },
};

export const CertificatesPage = {
  en: {
    'Gift certificates': 'Gift certificates',
    'No certificates available': 'No certificates available',
  },
  uk: {
    'Gift certificates': 'Подарункові сертифікати',
    'No certificates available': 'Сертифікати відсутні',
  },
};

export const CertificatePage = {
  en: {
    Cost: 'Cost',
    'Certificate includes': 'What is included',
    'Certificate locations': 'Valid at',
    'Certificate deposit line': 'Deposit',
    'Certificate purchase failed':
      'Could not start the purchase. Please try again.',
    'Certificate purchase unavailable':
      'Payment is temporarily unavailable. Please contact the administrator.',
  },
  uk: {
    Cost: 'Вартість',
    'Certificate includes': 'Що входить',
    'Certificate locations': 'Діє в локаціях',
    'Certificate deposit line': 'Депозит',
    'Certificate purchase failed':
      'Не вдалося розпочати покупку. Спробуйте ще раз, будь ласка.',
    'Certificate purchase unavailable':
      'Оплата тимчасово недоступна. Зверніться, будь ласка, до адміністратора.',
  },
};

export const ClientCertificatesPage = {
  en: {
    ...CERTIFICATE_STATUS.en,
    'My certificates': 'My certificates',
    'No purchased certificates': 'You have no certificates yet',
    'Browse gift certificates': 'Browse gift certificates',
    'Certificate balance': 'Balance',
    'Certificate expires at': 'Valid until',
    'Certificates failed to load':
      'Could not load your certificates. Please try again later.',
  },
  uk: {
    ...CERTIFICATE_STATUS.uk,
    'My certificates': 'Мої сертифікати',
    'No purchased certificates': 'У вас ще немає сертифікатів',
    'Browse gift certificates': 'Переглянути подарункові сертифікати',
    'Certificate balance': 'Залишок',
    'Certificate expires at': 'Діє до',
    'Certificates failed to load':
      'Не вдалося завантажити ваші сертифікати. Спробуйте пізніше, будь ласка.',
  },
};

export const ClientCertificatePage = {
  en: {
    ...CERTIFICATE_STATUS.en,
    'Certificate face value': 'Face value',
    'Certificate balance': 'Balance',
    'Certificate purchased at': 'Purchased on',
    'Certificate expires at': 'Valid until',
    'Certificate includes': 'What is included',
    'Certificate deposit line': 'Deposit',
    'Certificate remaining': 'Remaining',
    'Certificate failed to load':
      'Could not load the certificate. Please try again later.',
  },
  uk: {
    ...CERTIFICATE_STATUS.uk,
    'Certificate face value': 'Номінал',
    'Certificate balance': 'Залишок',
    'Certificate purchased at': 'Придбано',
    'Certificate expires at': 'Діє до',
    'Certificate includes': 'Що входить',
    'Certificate deposit line': 'Депозит',
    'Certificate remaining': 'Залишилось',
    'Certificate failed to load':
      'Не вдалося завантажити сертифікат. Спробуйте пізніше, будь ласка.',
  },
};
